import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SportCompetitionPageFragmentDoc } from '../fragments/SportCompetitionPageV2.fragment';
export type GetCompetitionPageV2QueryVariables = Types.Exact<{
	after?: Types.InputMaybe<Types.Scalars['String']['input']>;
	country: Types.Scalars['Country']['input'];
	filter?: Types.InputMaybe<Types.SportEventFilter>;
	withOffers?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	first: Types.Scalars['Int']['input'];
	fullPath: Types.Scalars['String']['input'];
	site?: Types.InputMaybe<Types.Scalars['String']['input']>;
	language: Types.Scalars['Language']['input'];
	platform: Types.Platform;
	timezoneOffset: Types.Scalars['Int']['input'];
	sortOrder?: Types.SortOrder;
}>;

export type GetCompetitionPageV2Query = {
	__typename?: 'Query';
	urlV2: {
		__typename?: 'Url';
		id: string;
		urlID: number;
		locale: string;
		objectType: Types.ObjectType;
		fullPath: string;
		heading1?: string | null;
		node:
			| { __typename?: 'Article'; id: string }
			| { __typename?: 'Author'; id: string }
			| { __typename?: 'Bundle'; id: string }
			| { __typename?: 'Device'; id: string }
			| { __typename?: 'Episode'; id: string }
			| { __typename?: 'GenericTitleList'; id: string }
			| { __typename?: 'Genre'; id: string }
			| { __typename?: 'HomePage'; id: string }
			| { __typename?: 'Movie'; id: string }
			| { __typename?: 'MultiStepSportEvent'; id: string }
			| { __typename?: 'Offer'; id: string }
			| { __typename?: 'OfferHistory'; id: string }
			| { __typename?: 'Package'; id: string }
			| { __typename?: 'Page'; id: string }
			| { __typename?: 'Person'; id: string }
			| { __typename?: 'PressRelease'; id: string }
			| { __typename?: 'ProfileV2'; id: string }
			| { __typename?: 'Season'; id: string }
			| { __typename?: 'Show'; id: string }
			| { __typename?: 'SingleStepSportEvent'; id: string }
			| {
					__typename?: 'SportCompetitionV2';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					sport: Types.SportType;
					content: {
						__typename?: 'SportCompetitionContentV2';
						name: string;
						fullPath: string;
						iconUrl?: string | null;
					};
					activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
					sportEventsV2: {
						__typename?: 'SportEventsConnectionV2';
						pageInfo: {
							__typename?: 'PageInfo';
							startCursor: string;
							endCursor: string;
							hasPreviousPage: boolean;
							hasNextPage: boolean;
						};
						edges?: Array<{
							__typename?: 'SportEventsEdgeV2';
							node:
								| {
										__typename?: 'MultiStepSportEvent';
										id: string;
										objectId: number;
										sport: Types.SportType;
										offerCount: number;
										competition?: {
											__typename?: 'SportCompetitionV2';
											id: string;
											objectId: number;
											activeSeason?: {
												__typename?: 'SportSeason';
												name: string;
												seasonID: number;
											} | null;
										} | null;
										content: {
											__typename?: 'MultiStepSportEventContent';
											startAt: any;
											endAt?: any | null;
											status: Types.SportEventStatus;
											fullPath?: string | null;
											venue?: { __typename?: 'SportVenue'; name: string; venueID: number } | null;
											competitionStage: {
												__typename?: 'SportCompetitionStageV2';
												name: Types.SportCompetitionStageName;
												number?: number | null;
											};
										};
										parent?: {
											__typename?: 'MultiStepSportEvent';
											id: string;
											content: {
												__typename?: 'MultiStepSportEventContent';
												name: string;
												fullPath?: string | null;
												startAt: any;
												status: Types.SportEventStatus;
											};
										} | null;
										watchNowOffer?: {
											__typename?: 'SportOffer';
											monetizationType: Types.MonetizationType;
											presentationType: Types.PresentationType;
											audioLanguage?: string | null;
											standardWebURL?: string | null;
											sportObjectType: Types.SportObjectType;
											package: {
												__typename?: 'Package';
												id: string;
												packageId: number;
												technicalName: string;
												clearName: string;
												shortName: string;
												monetizationTypes: Array<Types.MonetizationType>;
												iconWide: string;
											};
										} | null;
										offers?: Array<{
											__typename?: 'SportOffer';
											monetizationType: Types.MonetizationType;
											presentationType: Types.PresentationType;
											audioLanguage?: string | null;
											standardWebURL?: string | null;
											sportObjectType: Types.SportObjectType;
											package: {
												__typename?: 'Package';
												id: string;
												packageId: number;
												technicalName: string;
												clearName: string;
												shortName: string;
												monetizationTypes: Array<Types.MonetizationType>;
											};
										}>;
								  }
								| {
										__typename?: 'SingleStepSportEvent';
										id: string;
										objectId: number;
										sport: Types.SportType;
										offerCount: number;
										competition?: {
											__typename?: 'SportCompetitionV2';
											id: string;
											objectId: number;
											activeSeason?: {
												__typename?: 'SportSeason';
												name: string;
												seasonID: number;
											} | null;
										} | null;
										content: {
											__typename?: 'SingleStepSportEventContent';
											startAt: any;
											endAt?: any | null;
											status: Types.SportEventStatus;
											fullPath?: string | null;
											venue?: { __typename?: 'SportVenue'; name: string; venueID: number } | null;
											competitionStage: {
												__typename?: 'SportCompetitionStageV2';
												name: Types.SportCompetitionStageName;
												number?: number | null;
											};
										};
										competitors: {
											__typename?: 'SingleStepSportCompetitorsV2';
											homeTeam: {
												__typename?: 'SingleStepSportCompetitorV2';
												score?: number | null;
												winner: boolean;
												competitors: Array<{
													__typename?: 'SportCompetitorV2';
													id: string;
													objectId: number;
													content: {
														__typename?: 'SportCompetitorContentV2';
														name: string;
														iconUrl?: string | null;
														fullPath?: string | null;
													};
												}>;
											};
											awayTeam: {
												__typename?: 'SingleStepSportCompetitorV2';
												score?: number | null;
												winner: boolean;
												competitors: Array<{
													__typename?: 'SportCompetitorV2';
													id: string;
													objectId: number;
													content: {
														__typename?: 'SportCompetitorContentV2';
														name: string;
														iconUrl?: string | null;
														fullPath?: string | null;
													};
												}>;
											};
										};
										watchNowOffer?: {
											__typename?: 'SportOffer';
											monetizationType: Types.MonetizationType;
											presentationType: Types.PresentationType;
											audioLanguage?: string | null;
											standardWebURL?: string | null;
											sportObjectType: Types.SportObjectType;
											package: {
												__typename?: 'Package';
												id: string;
												packageId: number;
												technicalName: string;
												clearName: string;
												shortName: string;
												monetizationTypes: Array<Types.MonetizationType>;
												iconWide: string;
											};
										} | null;
										offers?: Array<{
											__typename?: 'SportOffer';
											monetizationType: Types.MonetizationType;
											presentationType: Types.PresentationType;
											audioLanguage?: string | null;
											standardWebURL?: string | null;
											sportObjectType: Types.SportObjectType;
											package: {
												__typename?: 'Package';
												id: string;
												packageId: number;
												technicalName: string;
												clearName: string;
												shortName: string;
												monetizationTypes: Array<Types.MonetizationType>;
											};
										}>;
								  };
						}> | null;
					};
			  }
			| { __typename?: 'SportCompetitorV2'; id: string }
			| { __typename?: 'SportMatch'; id: string }
			| { __typename?: 'Url'; id: string }
			| { __typename?: 'UserProviderSubscription'; id: string };
	};
};

export const GetCompetitionPageV2Document = gql`
	query GetCompetitionPageV2(
		$after: String
		$country: Country!
		$filter: SportEventFilter
		$withOffers: Boolean = true
		$first: Int!
		$fullPath: String!
		$site: String
		$language: Language!
		$platform: Platform!
		$timezoneOffset: Int!
		$sortOrder: SortOrder! = ASC
	) {
		urlV2(fullPath: $fullPath, site: $site) {
			id
			urlID
			locale
			objectType
			fullPath
			heading1
			node {
				id
				...SportCompetitionPage
			}
		}
	}
	${SportCompetitionPageFragmentDoc}
`;
